import React, { useMemo } from "react";
import { Avatar, Box, Typography } from "@mui/material";
import ChatBackIcon from "../../../../../assets/svg-fc/ChatBackIcon";
import IsMobile from "../../../../../hooks/isMobile";
import { formatDate, getStringsFirstLetter, isObjectEmpty } from "../../../../../utils/commonUtils";
import { MESSAGES_LOGO_COLORS, AVATAR_TEXT_COLORS } from "../../../../../theme/palette";
import palette from "../../../../../theme/palette";
import ChatHeaderMetadata from "../ChatHeaderMetadata/ChatHeaderMetadata";
import { IEventDetailMessages } from "../../../../../types/eventTypes";
import { iEventType } from "../../../../../types/eventTypes";
import { ICorporateEvent, ICorporateEventMessage } from "../../../../../interfaces/corporateEvent";
import { getEventTypeFromEventObject } from "../../../../../helpers/common";
import { EventTypeFilterEnum } from "../../../../../constants/enums";
import youCaterAvatar from "../../../../../assets/images/youCaterAvatar.png";
import "./ChatHeaderLeftSection.scss";

interface ChatHeaderLeftSectionProps {
	chatMessage: IEventDetailMessages | ICorporateEventMessage;
	eventDetail: iEventType | ICorporateEvent;
	chatIndex?: number;
	onBackClick?: () => void;
}

const bgColors = Object.values(MESSAGES_LOGO_COLORS);

const ChatHeaderLeftSection: React.FC<ChatHeaderLeftSectionProps> = ({
	chatMessage,
	eventDetail,
	onBackClick,
	chatIndex = 0,
}) => {
	const isMobile = IsMobile();
	const eventType = getEventTypeFromEventObject(eventDetail);

	const getAvatarBgColor = (index: number): string => {
		return bgColors[index % bgColors.length];
	};

	const getAvatarTextColor = (bgColor: string): string => {
		return AVATAR_TEXT_COLORS[bgColor] || palette.grey["1100"];
	};

	const avatarBg = getAvatarBgColor(chatIndex);
	const avatarTextColor = getAvatarTextColor(avatarBg);

	const customerDetails = useMemo(() => {
		if (eventType !== EventTypeFilterEnum.B2B) {
			if (isObjectEmpty(eventDetail))
				return {
					customerFirstLastName: "",
					eventName: "",
					eventDate: "",
					customerName: "",
				};
			const eventDetailWithType = eventDetail as iEventType;
			return {
				customerFirstLastName: getStringsFirstLetter(
					eventDetailWithType.customer?.firstName,
					eventDetailWithType.customer?.lastName,
				),
				eventName: eventDetailWithType?.name,
				eventDate: formatDate(eventDetailWithType.eventDate, false),
				customerName: `${eventDetailWithType.customer?.firstName} ${eventDetailWithType.customer?.lastName}`,
			};
		}
	}, [eventDetail, eventType]);

	return (
		<Box className="chatHeaderLeft">
			<Box className="chatHeaderAvatar">
				{isMobile && onBackClick && (
					<Box className="chatHeaderBackIcon" onClick={onBackClick}>
						<ChatBackIcon size="18" />
					</Box>
				)}
				{eventType === EventTypeFilterEnum.B2B ? (
					<Avatar className="avatarBackground" src={youCaterAvatar} />
				) : (
					<Box className="avatarBackground" sx={{ backgroundColor: avatarBg }}>
						<Typography className="avatarText" sx={{ color: avatarTextColor }}>
							{customerDetails?.customerFirstLastName || ""}
						</Typography>
					</Box>
				)}
			</Box>
			<Box className="eventInfo">
				<Typography className="eventName">{eventDetail?.name || ""}</Typography>
				<ChatHeaderMetadata eventDetail={eventDetail} chatMessage={chatMessage} />
			</Box>
		</Box>
	);
};

export default ChatHeaderLeftSection;
